import { render, staticRenderFns } from "./QuickAgentForm.vue?vue&type=template&id=22f98aa7&scoped=true"
import script from "./QuickAgentForm.vue?vue&type=script&lang=js"
export * from "./QuickAgentForm.vue?vue&type=script&lang=js"
import style0 from "./QuickAgentForm.vue?vue&type=style&index=0&id=22f98aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f98aa7",
  null
  
)

export default component.exports